import { Link } from 'react-router-dom';
import SectionHeading from '@/components/feature/SectionHeading';
import { categories } from '@/mocks/categories';
import type { Category } from '@/types/content';

const cats = categories as Category[];

export default function CategorySection() {
  return (
    <section id="categories" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-8 lg:px-12">
        <SectionHeading
          eyebrow="Library"
          title="主题分类"
          desc="五个档期栏目，对应五种追更节奏。想集中补课就按分类进，想随便看看就从热度榜走。"
          linkTo="/topics"
          linkLabel="浏览全部瓜料"
        />
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {cats.map((c, i) => (
            <Link
              key={c.id}
              to={`/topics?cat=${c.id}`}
              className={`group rounded-lg border border-background-200 bg-background-50 p-6 hover:border-primary-300 transition-colors ${
                i === 0 ? 'sm:col-span-2 lg:col-span-1' : ''
              }`}
            >
              <div className="flex items-center justify-between mb-5">
                <span className="w-12 h-12 rounded-lg bg-primary-50 text-primary-600 flex items-center justify-center group-hover:bg-primary-500 group-hover:text-background-50 transition-colors">
                  <i className={`${c.icon} text-2xl`} aria-hidden="true"></i>
                </span>
                <span className="font-heading text-3xl font-bold text-background-300 group-hover:text-primary-100 transition-colors">
                  {String(i + 1).padStart(2, '0')}
                </span>
              </div>
              <h3 className="font-heading text-lg font-bold text-foreground-950 group-hover:text-primary-600 transition-colors">
                {c.name}
              </h3>
              <p className="mt-2 text-sm text-foreground-600 leading-7 line-clamp-2">{c.desc}</p>
              <span className="mt-5 inline-flex items-center gap-1.5 text-xs text-foreground-500">
                <i className="ri-bookmark-3-line" aria-hidden="true"></i>
                {c.count} 篇精选
              </span>
            </Link>
          ))}
          <div className="rounded-lg border border-dashed border-background-300 bg-background-50 p-6 flex flex-col justify-center">
            <h3 className="font-heading text-lg font-bold text-foreground-950">找不到想要的档期？</h3>
            <p className="mt-2 text-sm text-foreground-600 leading-7">
              在瓜料库用关键词搜索，或按时间倒序翻一翻历史瓜料。
            </p>
            <Link
              to="/topics"
              className="mt-5 inline-flex items-center gap-1.5 px-5 py-2.5 rounded-md bg-foreground-950 text-background-50 text-sm font-medium whitespace-nowrap self-start hover:bg-primary-600 transition-colors"
            >
              <i className="ri-search-line" aria-hidden="true"></i>
              去瓜料库找找
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}